import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Marilyn Chipont",
    rating: 5,
    content: "Je suis très très satisfaite du travail de Céline, ma fille a bien progressé et a gagné en confiance. Merci pour la qualité de son écoute, de sa pédagogie, nous continuons cette année. Bravo",
    date: "Août 2024"
  },
  {
    name: "Diaraby AM",
    rating: 5,
    content: "Céline est extrêmement engagée, à l'écoute des parents et des enfants, professionnelle, elle apporte sa douceur et une bonne humeur communicative, nécessaires pour qu'apprentissage rime avec plaisir !",
    date: "Septembre 2024"
  },
  {
    name: "Rafael Da Costa",
    rating: 5,
    content: "Merci Céline pour son investissement et son accessibilité. Jamais je n'aurais pensé que le soutien scolaire m'aurait apporté autant. Encore merci Céline pour tout ce que tu m'as apporté.",
    date: "Août 2024"
  },
  {
    name: "Jonathan NAVEAU",
    rating: 5,
    content: "Ma fille de 5 ans prend des cours d'anglais depuis deux ans, très bonne pédagogie, elle est ravie et nous aussi",
    date: "Mars 2024"
  },
  {
    name: "Edouard Lasnier",
    rating: 5,
    content: "Excellent professeur, s'adapte à tous les niveaux. M'aide à obtenir le concours des sapeurs pompiers professionnels. Je recommande ++",
    date: "Septembre 2025"
  },
  {
    name: "Noémie Lemaire",
    rating: 5,
    content: "Une excellente équipe à l'écoute, qui a su répondre à notre besoin. Cela fait des années que nous faisons confiance à Céline. Merci mille fois",
    date: "Septembre 2023"
  }
];

export const Testimonials = () => {
  return (
    <section
      id="temoignages"
      data-testid="testimonials-section"
      className="py-14 md:py-28 relative bg-gradient-to-b from-white to-blue-50"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-16"
        >
          <span className="inline-block text-blue-600 font-semibold mb-4 tracking-wider uppercase text-sm bg-blue-50 px-4 py-2 rounded-full">
            Témoignages
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold text-blue-900 mb-4 md:mb-6">
            Ce que disent nos familles
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={`header-star-${i}`} className="w-6 h-6 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="text-lg font-semibold text-blue-900">5.0/5</span>
            <a 
              href="https://www.google.com/search?q=Celine+Coutand+Tutoring+Grosrouvre"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-orange-500 transition-colors"
            >
              (16 avis Google)
            </a>
          </div>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              data-testid={`testimonial-card-${index}`}
              className="bg-white rounded-2xl p-6 shadow-lg border border-blue-100 hover:shadow-xl transition-shadow relative"
            >
              {/* Google Badge */}
              <div className="absolute top-4 right-4 flex items-center gap-1 text-xs text-gray-500">
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span>Google</span>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`${testimonial.name}-star-${i}`} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                ))}
              </div>

              {/* Content */}
              <p className="text-blue-800/80 leading-relaxed mb-4 text-sm">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-blue-900 text-sm">{testimonial.name}</div>
                    <div className="text-xs text-blue-600/60">{testimonial.date}</div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-12"
        >
          <a
            href="https://www.google.com/search?q=Celine+Coutand+Tutoring+Grosrouvre"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-orange-500 font-medium transition-colors"
          >
            <span>Voir tous les avis sur Google</span>
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
